const INSTALLATION = {
  PAGE_TITLE: ' نصب و راه اندازی | رایچت',

  HEADING_TITLE: 'نصب و راه اندازی',
  HEADING_SUBTITLE:
    'با استفاده از یکی از دو روش زیر رایچت را برروی وب سایت خود نصب کنید.',

  INSTALLATION_HELP: 'راهنمای نصب و فعال سازی',

  INSTALLATION_METHOD_1: 'روش اول:نصب دستی',
  INSTALLATION_METHOD_1_SUBTITLE:
    'کپی کردن کد داده شده قبل از تگ </head> در وبسایت.',

  SELECT_WEBSITE: 'انتخاب وبسایت',
  COPY_SCRIPT: 'کپی تکه کد',
  COPIED: 'کپی شد!',

  INSTALLATION_METHOD_2: 'روش دوم:افزونه',
  INSTALLATION_METHOD_2_SUBTITLE:
    'برای وبسایت‌هایی با سیستم مدیریت محتوا (CMS)، به راحتی با چند کلیک از رایچت استفاده کنید.',

  INSTALL_PLUGIN: 'نصب افزونه',

  WORDPRESS: 'وردپرس',
  JOOMLA: 'جوملا',
  DROPAL: 'دروپال',
  PRESTASHOP: ' پرستاشاپ ',
  WHMCS: 'whmcs',

  WEBSITE_TOKEN: 'توکن این وبسایت:',
  WIDGET_LINK: 'لینک مخصوص ابزارک:',
  CLICK_TO_COPY: 'برای کپی کلیک کنید!',
  NEW_VERSION: 'نسخه جدید',

  NORMAL_LOAD_TYPE: 'کد لود معمولی',
  SEO_FRIENDLY_LOAD_TYPE: 'کد لود مخصوص سئو',
  SPEEDY_LOAD_TYPE: 'کد لود سریع',
};

export default INSTALLATION;
